import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from "react-router";

import App from "./App";
import { store } from "./app/store";
import "./i18n";
import "./style.css";

Sentry.init({
	dsn: "https://9f863f86e3e36da2ec1b186a22d04d63@sentry2.sailingbyte.com/54",
	environment:
		import.meta.env.VITE_STAGE === "production" ? "production" : "test",
	integrations: [
		Sentry.reactRouterV7BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
		Sentry.replayIntegration(),
		Sentry.browserProfilingIntegration(),
	],
	tracesSampleRate: import.meta.env.VITE_STAGE === "production" ? 0.3 : 1.0,
	replaysSessionSampleRate:
		import.meta.env.VITE_STAGE === "production" ? 0.3 : 1.0,
	replaysOnErrorSampleRate: 1.0,
	tracePropagationTargets: ["*"],
	enabled: import.meta.env.PROD,
	debug: import.meta.env.VITE_STAGE === "test",
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	// <React.StrictMode>
	<Provider store={store}>
		<App />
	</Provider>
	// </React.StrictMode>
);
